// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3rHp8","label":"CategoryService_label__3Yj3A","location":"CategoryService_location__3SY35"};